<template>
  <section>
    <section class="calc-box-container">
      <!-- 左侧 -->
      <div class="calc-box-left">
        <div class="text-box f-dir-c ai-center">
          <div class="label">油费总额</div>
          <div class="value amount-color">
            {{
              (
                (orderData.orderFee.preOilVirtualFee +
                  orderData.orderFee.preOilFee) /
                100
              ).toFixed(2)
            }}元
          </div>
        </div>
        <div class="text-box f-dir-c ai-center">
          <div class="label">总耗油量</div>
          <div class="value amount-color">
            {{ orderData.orderFeeExt.oilLitreTotal / 100 }}升
          </div>
        </div>
      </div>
      <!-- 间隔线 -->
      <div class="calc-box-separate"></div>
      <!-- 右侧 -->
      <div class="calc-box-right">
        <div class="calc-row">
          <div class="row-label-box">
            <div class="row-label">
              油账户：<span class="amount-color"
                >{{ orderData.orderFee.preOilVirtualFee / 100 }}元</span
              >
            </div>
            <div class="row-label">
              总升数：<span class="amount-color"
                >{{ orderData.orderFeeExt.oilLitreVirtual / 100 }}升</span
              >
            </div>
          </div>
          <div class="row-content-box">
            <div
              class="row-content"
              v-for="(item, index) in orderData.schemes"
              :key="index"
            >
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label oil-depot">{{ item.oilDepotName }}</div>
                </div>
              </div>
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label">金额：</div>
                  <div class="value amount-color">
                    {{
                      item.oilDepotFee != null && item.oilDepotFee != ''
                        ? item.oilDepotFee / 100.0
                        : 0
                    }}元
                  </div>
                </div>
              </div>
              <div class="row-symbol">=</div>
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label">加油升数：</div>
                  <div class="value amount-color">
                    {{
                      item.oilDepotLitre != null && item.oilDepotLitre != ''
                        ? item.oilDepotLitre / 100.0
                        : 0
                    }}升
                  </div>
                </div>
              </div>
              <div class="row-symbol">&times;</div>
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label">单价：</div>
                  <div class="value amount-color">
                    {{
                      item.oilDepotPrice != null && item.oilDepotPrice != ''
                        ? item.oilDepotPrice / 100.0
                        : 0
                    }}元/升
                  </div>
                </div>
              </div>
              <div class="row-symbol"></div>
              <div class="row-box">
                <div class="text-box ai-center">
                  <div class="label">距靠台地：</div>
                  <div class="value amount-color">
                    {{
                      item.dependDistance != null && item.dependDistance != ''
                        ? item.dependDistance / 1000.0
                        : 0
                    }}KM
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="calc-row">
          <div class="row-label">
            油卡金额：<span class="amount-color"
              >{{ orderData.orderFee.preOilFee / 100 }}元</span
            >
          </div>
          <div class="row-content oilcard-content">
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">金额：</div>
                <div class="value amount-color">
                  {{ orderData.orderFee.preOilFee / 100 }}元
                </div>
              </div>
            </div>
            <div class="row-symbol">=</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">加油升数：</div>
                <div class="value amount-color">
                  {{ orderData.orderFeeExt.oilLitreEntity / 100 }}升
                </div>
              </div>
            </div>
            <div class="row-symbol">+</div>
            <div class="row-box">
              <div class="text-box ai-center">
                <div class="label">单价：</div>
                <div class="value amount-color">
                  {{
                    orderData.orderFeeExt.oilPrice == null
                      ? 0
                      : (orderData.orderFeeExt.oilPrice / 100).toFixed(2)
                  }}元/升
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="calc-other-info">
      <div class="other-info-box">
        <div class="other-info-item">
          <span>预估成本：</span
          ><span class="amount-color"
            >{{ orderData.orderFeeExt.estFee / 100 }}元</span
          >
        </div>
        <div class="other-info-item">
          <el-popover placement="top" width="150" trigger="hover">
            <div style="text-align: center">
              <span
                class="primary cur"
                v-for="(item, index) in orderData.driverSubsidyDays"
                :key="index"
                >{{ item.userName }}:<em>{{ item.subsidyDay }}</em></span
              >
            </div>
            <span slot="reference"
              >补贴<i class="el-icon-question warning"></i>：</span
            >
          </el-popover>

          <span class="amount-color"
            >{{
              (
                (orderData.orderFeeExt.copilotSalary +
                  orderData.orderFeeExt.salary +
                  orderData.orderFeeExt.driverSwitchSubsidy) /
                100
              ).toFixed(2)
            }}元</span
          >
        </div>
        <div class="other-info-item">
          <span>油费：</span
          ><span class="amount-color"
            >{{
              (
                (orderData.orderFee.preOilVirtualFee +
                  orderData.orderFee.preOilFee) /
                100
              ).toFixed(2)
            }}元</span
          >
        </div>
        <div class="other-info-item">
          <span>路桥费：</span
          ><span class="amount-color"
            >{{ orderData.orderFeeExt.pontage / 100 }}元</span
          >
        </div>
      </div>
      <div
        class="other-info-box"
        v-if="
          orderData.orderFee.preOilVirtualFee > 0 ||
          orderData.orderFee.oilSelfVirtual > 0
        "
      >
        <div class="other-info-item">
          <span>分配油来源：</span
          ><span
            v-if="
              orderData.orderFee.preOilVirtualFee > 0 ||
              orderData.orderFee.oilSelfVirtual > 0
            "
            >{{
              orderData.orderFeeExt.oilConsumer === 1
                ? '本车队定点油'
                : orderData.orderFeeExt.oilConsumer === 2 &&
                  orderData.orderFeeExt.oilAccountType === 2
                ? '找油-无发票'
                : orderData.orderFeeExt.oilConsumer === 2 &&
                  orderData.orderFeeExt.oilAccountType === 3
                ? '找油-有发票'
                : orderData.orderFeeExt.oilConsumer === 3 &&
                  orderData.orderFeeExt.oilAccountType === 2
                ? '万金油-无发票'
                : orderData.orderFeeExt.oilConsumer === 3 &&
                  orderData.orderFeeExt.oilAccountType === 3
                ? '万金油-有发票'
                : ''
            }}</span
          >
        </div>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      default: () => ({
        orderScheduler: {},
        orderFee: {},
      }),
    },
  },
  data () {
    return {
      dispatchInfo: {},
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.amount-color {
  color: #ff5046;
}
.calc-box-container {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .text-box {
    font-size: 14px;
    border-radius: 2px;
    border-radius: 2px;
    display: flex;
    &:nth-of-type(2) {
      padding-top: 5px;
    }
    &.f-dir-r {
      flex-direction: row;
    }
    &.jc-center {
      justify-content: center;
    }
    .label {
      color: #333333;
    }
    .value {
      display: flex;
      .calc-chart-ipt {
        width: 38px;
        border: none;
        outline: none;
        &:only-child {
          width: 50px;
        }
      }
    }
  }

  .calc-box-left {
    padding: 5px 0px;
    .text-box {
      .label {
        line-height: 20px;
        word-break: keep-all;
        width: 70px;
      }
      .value {
        line-height: 20px;
        .calc-chart-ipt {
          width: 100%;
          margin-right: 0;
          text-align: center;
        }
      }
    }
  }
  .calc-box-separate {
    width: 9px;
    height: 80px;
    margin-left: 20px;
    position: relative;
    border: 1px solid #ededed;
    border-right: none;
    &:before {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 7.5px solid transparent;
      border-right: 8px rgba(224, 233, 243, 1) solid;
      border-bottom: 7.5px solid transparent;
      top: 50%;
      left: -8px;
      margin-top: -7.5px;
    }
    &:after {
      position: absolute;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-right: 9px #fff solid;
      border-bottom: 6px solid transparent;
      top: 50%;
      left: -7px;
      z-index: 2;
      margin-top: -7.5px;
    }
  }
  .calc-box-right {
    display: flex;
    flex-direction: column;
    .row-title {
      margin-bottom: 14px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      :first-child {
        width: 174px;
      }
      :nth-last-child(1) {
        width: 180px;
        text-align: right;
      }
      :nth-last-child(2) {
        width: 300px;
        text-align: center;
      }
    }
    .calc-row {
      display: flex;
      flex-direction: row;
      &:nth-of-type(2) {
        padding-top: 0;
      }
      .row-label-box {
        display: flex;
        flex-direction: column;
        .row-label {
          height: 30px;
        }
      }
      .row-label {
        margin: 0 20px 0 12px;
        word-break: keep-all;
        min-width: 140px;
      }
      .row-content-box {
        display: flex;
        flex-direction: column;
        .row-content {
          height: 30px;
        }
      }
      .row-content {
        &.oilcard-content {
        }
        display: flex;
        flex-direction: row;
        align-items: center;
        .row-box {
          // width: 120px;
          &:first-child {
            .text-box {
              .oil-depot {
                width: 120px;
                margin-right: 20px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .text-box {
            &:only-child {
              box-sizing: border-box;
            }
            &:nth-of-type(2) {
              margin-top: -1px;
            }
            .label {
              word-break: keep-all;
            }
          }
        }
        .row-symbol {
          font-size: 14px;
          color: #bcbbbb;
          margin: 0 10px;
        }
      }
    }
  }
}
.calc-other-info {
  .other-info-box {
    display: flex;
    .other-info-item {
      margin-right: 40px;
    }
  }
}
</style>
